import { Injectable } from '@angular/core';
import { catchError, map, retry } from 'rxjs/operators';
import { CmxHttpClient } from './api.service';
import { Store } from '@ngrx/store';
import { CopyrightResponse } from '../typings/copyright';
import { SetCopyright } from '../store/actions';
import { State } from '../typings';

@Injectable()
export class CopyrightService {
  constructor(
    private store: Store<State>,
    private http: CmxHttpClient,
  ) {}

  fetchCopyright() {
    const apiUrl = `v5/legal/copyrights`;
    this.http
      .get<CopyrightResponse>(apiUrl)
      .pipe(
        retry(3),
        map((response) => {
          const copyrightData = response.DocumentLanguages;
          this.store.dispatch(new SetCopyright(copyrightData));
        }),
        catchError(() => {
          this.store.dispatch(new SetCopyright([]));
          return null;
        }),
      )
      .subscribe();
  }
}
